<guest-help-feedback-mobile *ngIf="!isDesktop"></guest-help-feedback-mobile>
<guest-help-feedback-desktop *ngIf="isDesktop"></guest-help-feedback-desktop>